import React from 'react';
import { useNavigate } from 'react-router-dom';

const TermsOfServicePage = () => {
  const navigate = useNavigate();

  return (
    <div style={{ background: 'var(--bg-page)', paddingTop: '80px', minHeight: '100vh' }}>
      <div className="container" style={{ padding: '3rem 1.2rem', maxWidth: '900px', margin: '0 auto' }}>
        <button
          onClick={() => navigate(-1)}
          style={{
            background: 'none',
            border: 'none',
            color: '#22c55e',
            cursor: 'pointer',
            marginBottom: '2rem',
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem',
          }}
        >
          ← Back
        </button>

        <h1 className="heading-1" style={{ marginBottom: '2rem' }}>Terms of Service</h1>
        <p className="body-small" style={{ color: 'var(--text-muted)', marginBottom: '2rem' }}>Last updated: January 2025</p>

        <div style={{ color: 'var(--text-secondary)', lineHeight: '1.8' }}>
          <h2 className="heading-3" style={{ marginBottom: '1rem', marginTop: '2rem' }}>1. Acceptance of Terms</h2>
          <p className="body-medium" style={{ marginBottom: '1rem' }}>
            By accessing and using the Ayurmed Global website and services, you accept and agree to be bound by these 
            Terms of Service. If you do not agree to these terms, please do not use our services.
          </p>

          <h2 className="heading-3" style={{ marginBottom: '1rem', marginTop: '2rem' }}>2. Services Description</h2>
          <p className="body-medium" style={{ marginBottom: '1rem' }}>
            Ayurmed Global provides AI-powered Ayurvedic healthcare integration services, including hospital management software, 
            equipment procurement, expert network services, and healthcare consulting. All services are subject to availability 
            and may be modified at our discretion.
          </p>

          <h2 className="heading-3" style={{ marginBottom: '1rem', marginTop: '2rem' }}>3. User Responsibilities</h2>
          <p className="body-medium" style={{ marginBottom: '1rem' }}>
            Users agree to provide accurate information, maintain the confidentiality of their account credentials, 
            and use our services only for lawful purposes. You are responsible for all activities that occur under your account.
          </p>

          <h2 className="heading-3" style={{ marginBottom: '1rem', marginTop: '2rem' }}>4. Intellectual Property</h2>
          <p className="body-medium" style={{ marginBottom: '1rem' }}>
            All content, trademarks, and intellectual property on this website are owned by Ayurmed Global. 
            You may not reproduce, distribute, or create derivative works without our express written permission.
          </p>

          <h2 className="heading-3" style={{ marginBottom: '1rem', marginTop: '2rem' }}>5. Limitation of Liability</h2>
          <p className="body-medium" style={{ marginBottom: '1rem' }}>
            Ayurmed Global shall not be liable for any indirect, incidental, special, consequential, or punitive damages 
            resulting from your use of our services. Our total liability shall not exceed the amount paid by you for our services.
          </p>

          <h2 className="heading-3" style={{ marginBottom: '1rem', marginTop: '2rem' }}>6. Governing Law</h2>
          <p className="body-medium" style={{ marginBottom: '1rem' }}>
            These Terms of Service shall be governed by and construed in accordance with the laws of India. 
            Any disputes shall be subject to the exclusive jurisdiction of courts in Faridabad, Haryana.
          </p>

          <h2 className="heading-3" style={{ marginBottom: '1rem', marginTop: '2rem' }}>7. Contact Information</h2>
          <p className="body-medium" style={{ marginBottom: '1rem' }}>
            For questions about these Terms of Service, please contact us at:<br />
            Email: info@ayurmedglobal.com<br />
            Phone: +91-9958096324
          </p>
        </div>
      </div>
    </div>
  );
};

export default TermsOfServicePage;
